import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["../../app.component.css"]
})
export class HomeComponent implements OnInit {
  baseUrl;

  ngOnInit() {
    this.baseUrl = environment.baseUrl
    this.goToAtbAtHome()
  }

  goToAtbAtHome() {
    window.location.href = environment.restBaseRedirect + 'home';
  }
}


// WEBPACK FOOTER //
// ./src/app/views/home/home.component.ts